export default function CreativeDemoFactory() {
  const service = {};

  const demos = {
    enhancedDisplay: {
      advertiser: 'Sponsored',
      description: "Don't miss this content from our sponsor",
      action: 'banner',
      adm: '<ins></ins>',
      headline: 'Click Here for More Information'
    },
    scroller: {
      advertiser: 'Sharethrough',
      brandLogoUrl: 'https://legacy-design-assets.s3.amazonaws.com/images/favicon.png',
      description:
        'Our native advertising software is helping the Internet evolve beyond interruptive ads.',
      mediaUrl: 'https://www.sharethrough.com',
      action: 'scroller',
      customEngagementLabel: '',
      customEngagementUrl: '',
      headline: 'Sharethrough - Native Advertising Software For Publishers',
      thumbnailUrl: '',
      scrollDirection: 'bottom_to_top'
    },
    slideshow: {
      advertiser: 'Sharethrough',
      brandLogoUrl: 'https://legacy-design-assets.s3.amazonaws.com/images/favicon.png',
      description:
        'Our native advertising software is helping the Internet evolve beyond interruptive ads.',
      mediaUrl: 'https://www.sharethrough.com',
      action: 'slideshow',
      customEngagementLabel: '',
      customEngagementUrl: '',
      headline: 'Sharethrough - Native Advertising Software For Publishers',
      thumbnailUrl:
        'https://static.sharethrough.com/creative_workflow/creative_thumbnails/78638/images/original/sharethrough-og-hero.jpg',
      slides: []
    },
    fullAdCarousel: {
      advertiser: 'Sharethrough',
      brandLogoUrl: 'https://legacy-design-assets.s3.amazonaws.com/images/favicon.png',
      description:
        'Our native advertising software is helping the Internet evolve beyond interruptive ads.',
      mediaUrl: 'https://www.sharethrough.com',
      action: 'carousel',
      customEngagementLabel: '',
      customEngagementUrl: '',
      headline: 'Sharethrough - Native Advertising Software For Publishers',
      thumbnailUrl:
        'https://static.sharethrough.com/creative_workflow/creative_thumbnails/78638/images/original/sharethrough-og-hero.jpg',
      slides: [
        {
          headline: 'Sharethrough - Native Advertising Software For Publishers',
          description:
            'Our native advertising software is helping the Internet evolve beyond interruptive ads.',
          thumbnailUrl:
            'https://static.sharethrough.com/creative_workflow/creative_thumbnails/78638/images/original/sharethrough-og-hero.jpg',
          mediaUrl: 'https://www.sharethrough.com'
        },
        {
          headline: 'Sharethrough - Native Advertising Software For Publishers',
          description:
            'Our native advertising software is helping the Internet evolve beyond interruptive ads.',
          thumbnailUrl:
            'https://static.sharethrough.com/creative_workflow/creative_thumbnails/78638/images/original/sharethrough-og-hero.jpg',
          mediaUrl: 'https://www.sharethrough.com'
        }
      ]
    },
    outstream: {
      action: 'outstream',
      advertiser: 'Sponsor',
      description: 'Like this video? Click here to learn more.',
      mediaUrl:
        'https://static.sharethrough.com/m/hosted_video/preview-17/video.mp4',
      forceClickToPlay: false,
      headline: 'Watch this video for more information',
      thumbnailUrl:
        'https://legacy-design-assets.s3.amazonaws.com/images/click-for-more.png'
    },
    isiWebsiteVisit: {
      advertiser: 'Sharethrough',
      brandLogoUrl: 'https://legacy-design-assets.s3.amazonaws.com/images/favicon.png',
      description:
        'Our native advertising software is helping the Internet evolve beyond interruptive ads.',
      mediaUrl: 'https://www.sharethrough.com',
      action: 'clickout',
      customEngagementLabel: '',
      customEngagementUrl: '',
      headline: 'Sharethrough - Native Advertising Software For Publishers',
      thumbnailUrl:
        'https://static.sharethrough.com/creative_workflow/creative_thumbnails/78638/images/original/sharethrough-og-hero.jpg',
      isiText: '',
      isiAutoscroll: false
    },
    isiInstantPlayCard: {
      advertiser: 'Sharethrough',
      brandLogoUrl: 'https://legacy-design-assets.s3.amazonaws.com/images/favicon.png',
      description:
        'Our native advertising software is helping the Internet evolve beyond interruptive ads.',
      mediaUrl:
        'https://static.sharethrough.com/m/hosted_video/preview-17/video.mp4',
      action: 'hosted-video',
      instantPlayMobileCount: 48,
      instantPlayMobileUrl:
        'https://static.sharethrough.com/m/instant_play_mobile/preview-17/sprite0.jpg',
      videoAspectRatio: 0.5625,
      instantPlayMobileWidth: 320,
      instantPlayMobileHeight: 180,
      forceClickToPlay: false,
      customEngagementLabel: '',
      customEngagementUrl: '',
      headline: 'Sharethrough - Native Advertising Software For Publishers',
      thumbnailUrl:
        'https://static.sharethrough.com/creative_workflow/creative_thumbnails/78638/images/original/sharethrough-og-hero.jpg',
      isiText: '',
      isiAutoscroll: false
    },
    websiteVisit: {
      advertiser: 'Sharethrough',
      brandLogoUrl: 'https://legacy-design-assets.s3.amazonaws.com/images/favicon.png',
      description:
        'Our native advertising software is helping the Internet evolve beyond interruptive ads.',
      mediaUrl: 'https://www.sharethrough.com',
      action: 'clickout',
      customEngagementLabel: '',
      customEngagementUrl: '',
      headline: 'Sharethrough - Native Advertising Software For Publishers',
      thumbnailUrl:
        'https://static.sharethrough.com/creative_workflow/creative_thumbnails/78638/images/original/sharethrough-og-hero.jpg'
    },
    videoCard: {
      advertiser: 'Sharethrough',
      brandLogoUrl: 'https://legacy-design-assets.s3.amazonaws.com/images/favicon.png',
      description:
        'Our native advertising software is helping the Internet evolve beyond interruptive ads.',
      mediaUrl: 'https://www.youtube.com/watch?v=-sex656uR94',
      action: 'video',
      customEngagementLabel: '',
      customEngagementUrl: '',
      headline: 'Sharethrough - Native Advertising Software For Publishers',
      thumbnailUrl:
        'https://static.sharethrough.com/creative_workflow/creative_thumbnails/78638/images/original/sharethrough-og-hero.jpg'
    },
    instantPlayCardInstream: {
      advertiser: 'Sharethrough',
      brandLogoUrl: 'https://legacy-design-assets.s3.amazonaws.com/images/favicon.png',
      description:
        'Our native advertising software is helping the Internet evolve beyond interruptive ads.',
      mediaUrl:
        'https://static.sharethrough.com/m/hosted_video/preview-17/video.mp4',
      action: 'instream-video',
      instantPlayMobileCount: 48,
      instantPlayMobileUrl:
        'https://static.sharethrough.com/m/instant_play_mobile/preview-17/sprite0.jpg',
      videoAspectRatio: 0.5625,
      instantPlayMobileWidth: 320,
      instantPlayMobileHeight: 180,
      forceClickToPlay: false,
      customEngagementLabel: '',
      customEngagementUrl: '',
      headline: 'Sharethrough - Native Advertising Software For Publishers',
      thumbnailUrl:
        'https://static.sharethrough.com/creative_workflow/creative_thumbnails/78638/images/original/sharethrough-og-hero.jpg'
    },
    instantPlayCard: {
      advertiser: 'Sharethrough',
      brandLogoUrl: 'https://legacy-design-assets.s3.amazonaws.com/images/favicon.png',
      description:
        'Our native advertising software is helping the Internet evolve beyond interruptive ads.',
      mediaUrl:
        'https://static.sharethrough.com/m/hosted_video/preview-17/video.mp4',
      action: 'hosted-video',
      instantPlayMobileCount: 48,
      instantPlayMobileUrl:
        'https://static.sharethrough.com/m/instant_play_mobile/preview-17/sprite0.jpg',
      videoAspectRatio: 0.5625,
      instantPlayMobileWidth: 320,
      instantPlayMobileHeight: 180,
      forceClickToPlay: false,
      customEngagementLabel: '',
      customEngagementUrl: '',
      headline: 'Sharethrough - Native Advertising Software For Publishers',
      thumbnailUrl:
        'https://static.sharethrough.com/creative_workflow/creative_thumbnails/78638/images/original/sharethrough-og-hero.jpg'
    },
    skinnyCow: {
      advertiser: 'The Skinny Cow',
      brandLogoUrl:
        'https://dumb-waiter.s3.amazonaws.com/brand-logos/skinnycow.png',
      description:
        'Sunny with a chance of #IceCream. Tag your Skinny Cow moments with #skinnycow.',
      mediaUrl: 'https://instagram.com/p/oRYYg5GW5I/',
      action: 'clickout',
      customEngagementLabel: '',
      customEngagementUrl: '',
      headline: "It's easy to brag about your Skinny Cow moments",
      thumbnailUrl:
        'https://dumb-waiter.s3.amazonaws.com/nag/thumbnails/skinny-thumbnail.jpg'
    },
    airbnb: {
      advertiser: 'Airbnb',
      brandLogoUrl: '',
      description: 'Love this? Live there. $100 Off All Treehouses. Book Now.',
      mediaUrl:
        'https://static.sharethrough.com/bakery/hosted_video/4443d074/video.mp4',
      instantPlayMobileCount: 15,
      instantPlayMobileUrl:
        'https://static.sharethrough.com/m/instant_play_mobile/4443d074/sprite0.jpg',
      videoAspectRatio: 0.5625,
      instantPlayMobileWidth: 320,
      instantPlayMobileHeight: 180,
      action: 'hosted-video',
      customEngagementLabel: 'Book Your Treehouse',
      customEngagementUrl: 'https://www.airbnb.com/livethere/treehouse',
      forceClickToPlay: false,
      headline: 'Love This Treehouse? Try Living There.',
      thumbnailUrl:
        'https://static.sharethrough.com/m/creative_thumbnails/77692/images/thumb_320/hqdefault.jpg'
    },
    beatsYoutube: {
      advertiser: 'Beats by Dre',
      brandLogoUrl:
        'https://dumb-waiter.s3.amazonaws.com/brand-logos/beats.png',
      description: 'RE-ESTABLISHED 2014 - Powerbeats2 Wireless',
      mediaUrl: 'https://www.youtube.com/watch?v=YCOgaWSfxxs',
      instantPlayMobileCount: null,
      instantPlayMobileUrl: null,
      action: 'video',
      customEngagementLabel: 'Go to beatsmusic.com!',
      customEngagementUrl: 'https://www.beatsmusic.com/',
      headline: 'Beats by Dre Presents: LeBron James',
      thumbnailUrl:
        'https://dumb-waiter.s3.amazonaws.com/nag/thumbnails/beats-thumbnail.jpg'
    },
    spcaPinterest: {
      advertiser: 'San Francisco SPCA',
      brandLogoUrl: 'https://dumb-waiter.s3.amazonaws.com/brand-logos/spca.png',
      description:
        'Luxury Barkitecture: 10 Amazing Dog House Designs For The Over-Pampered Pup. My dogs can only dream..............',
      mediaUrl: 'https://bit.ly/1nZcvaU',
      instantPlayMobileCount: null,
      instantPlayMobileUrl: null,
      action: 'clickout',
      headline: 'Pet-Inspired Home Design',
      thumbnailUrl:
        'https://dumb-waiter.s3.amazonaws.com/nag/thumbnails/sfpca-thumbnail.jpg'
    },
    pillsbury: {
      advertiser: 'Pillsbury',
      brandLogoUrl:
        'https://dumb-waiter.s3.amazonaws.com/brand-logos/pillsbury.png',
      description:
        'Want to make just about the easiest waffles ever? These Cinnamon Roll Waffles with Cream Cheese Icing could not be any simpler... Or more delicious.',
      mediaUrl:
        'https://www.pillsbury.com/everyday-eats/breakfast-brunch/cinnamon-roll-waffles-how-to',
      instantPlayMobileCount: null,
      instantPlayMobileUrl: null,
      action: 'clickout',
      headline:
        'Want To Learn How To Make Cinnamon Roll Waffles? Of Course You Do.',
      thumbnailUrl:
        'https://dumb-waiter.s3.amazonaws.com/nag/thumbnails/pillsbury-thumbnail.jpg'
    },
    georgiaPower: {
      advertiser: 'Georgia Power',
      brandLogoUrl: '',
      description:
        'Imagine a life of zero emissions tests, oil changes or pumping gas. Learn how to Get Current and Drive Electric.',
      mediaUrl:
        'https://static.sharethrough.com/m/hosted_video/23UD1snUhCD1F7Rwb4miYA1x/video.mp4',
      instantPlayMobileCount: null,
      instantPlayMobileUrl: null,
      action: 'hosted-video',
      customEngagementLabel: 'Learn More',
      customEngagementUrl:
        'https://georgiapower.com/about-energy/electric-vehicles/home.cshtml',
      forceClickToPlay: true,
      headline: 'Make Today Your Last Trip To The Gas Pump. Drive Electric.',
      thumbnailUrl:
        '//static.sharethrough.com/m/creative_thumbnails/35260/images/thumb_320/Screen_Shot_2015-05-29_at_3.45.35_PM.jpg'
    },
    johnsonAndJohnson: {
      advertiser: 'Johnson & Johnson',
      brandLogoUrl:
        'https://dumb-waiter.s3.amazonaws.com/brand-logos/johnsonjohnson.png',
      description:
        'Yes, the smallest room in your house can actually make a big difference to the planet. Share this video to show your commitment.',
      mediaUrl: 'https://www.youtube.com/watch?v=nUwBTBpXCw8',
      instantPlayMobileCount: null,
      instantPlayMobileUrl: null,
      action: 'video',
      customEngagementUrl: '',
      customEngagementLabel: '',
      headline: 'Want to make kids happy? Recycle',
      thumbnailUrl:
        'https://dumb-waiter.s3.amazonaws.com/nag/thumbnails/johnson-thumbnail.jpg'
    },
    geYoutube: {
      advertiser: 'GE',
      brandLogoUrl: 'https://dumb-waiter.s3.amazonaws.com/brand-logos/ge.png',
      description:
        'Launched in the summer of 2011, the GE | OMD Incubator is an intensive 10-week startup incubator.',
      mediaUrl: 'https://www.youtube.com/embed/zuZvBfAS3RM?showinfo=0',
      instantPlayMobileCount: null,
      instantPlayMobileUrl: null,
      action: 'video',
      customEngagementUrl: '',
      customEngagementLabel: '',
      headline:
        'Startup Advice from Jack Dorsey, Jonah Peretti, and Dennis Crowley',
      thumbnailUrl:
        'https://dumb-waiter.s3.amazonaws.com/nag/thumbnails/ge-thumbnail.jpg'
    }
  };

  // deep clone
  service.getDemo = name => JSON.parse(JSON.stringify(demos[name] || {}));

  return service;
}
